import React, { useEffect, useState } from "react";
import { FiSettings } from "react-icons/fi";
import { AiOutlinePlus } from "react-icons/ai";
import { BiChevronRight } from "react-icons/bi";
import { BiChevronLeft } from "react-icons/bi";
import { Link } from "react-router-dom";
import CityTable from "../cityTable/CityTable";
import { Pagination } from "antd";

function ListCity({ data, handleDelete, getCitiesData, onChangeVal, initialVlue, handleChange, reset }) {
  const [count, setCount] = useState([])
  useEffect(() => {
    if (data?.totalPages) {
      const arrr = []
      for (let i = 0; i < data.totalPages; i++) {
        arrr.push(i + 1)
      }
      setCount(arrr);
    }
  }, [data])
  return (
    <>
      <div className="pageTableWrapper">
        <div className="pageHeader">
          <div className="pageTitle">
            <FiSettings />
            <h5>CITIES</h5>
          </div>

          <div className="addNew">
            <Link to="/admin/create-city" className="btn btn-success">
              <AiOutlinePlus /> Add New City
            </Link>
          </div>
        </div>

        <div className="pageBody">
          <CityTable data={data} handleDelete={handleDelete} initialVlue={initialVlue} handleChange={handleChange} getCitiesData={getCitiesData} reset={reset} />
        </div>


        <div className="pageFooter">
          <div className="row">
            <div className="col-md-6">
              <div className="showEntry">
                <p>Showing {data?.totalCities} entries</p>
              </div>
            </div>
            <div className="col-md-6">
              <Pagination
                defaultCurrent={1}
                onChange={onChangeVal}
                total={data?.totalCities}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default ListCity;
